import React from "react"

import Login from '@platform/shared/auth/Login'

const LoginView = () => {
  return (
    <React.Fragment>
      <Login />
    </React.Fragment>
  )
}
export default LoginView
